"use client"
import React, { useState } from 'react';
import { Checkbox, ConfigProvider, Form, Input, message, Spin } from 'antd';
import AuthRepo from '@/core/repos/auth.repo';
import container from '@/lib/di/container';
import { useNavigate } from 'react-router';

// interface ServiceFormProps{
//     // submitRef: MutableRefObject<HTMLButtonElement>,
// }
const App: React.FC = ({}) => {
    const navigate = useNavigate();
    const authRepo = container.get(AuthRepo);
    const [spinning, setSpinning] = useState(false);
    const [form] = Form.useForm();


    const onSubmit = async () => {
        const formData = await form.validateFields();
        if (formData) {
            setSpinning(true);
            const result = await authRepo.login({userName: formData.username, password: formData.password, rememberPassword: formData.rememberPassword});
            if (result) {
                navigate("/");
            } else {
                setSpinning(false);
                message.error("Tên đăng nhập hoặc mật khẩu không đúng!");
            }
        }
    };

    return (
        <div>
             <ConfigProvider theme={{
                token: {
                    borderRadius: 2,
                    colorBorder: "#ACBDCD",
                },
                components: {
                    Input: {
                        inputFontSize: 14,
                        paddingBlock: 6,
                    },
                    Select: {
                        fontSize: 14
                    },
                    Form: {
                        labelFontSize: 14,
                        itemMarginBottom: 6,
                        verticalLabelPadding: 2
                    }
                }
            }}>
                <Form
                    name="basic"
                    initialValues={{ remember: true }}
                    autoComplete="on"
                    layout="vertical"
                    form={form}
                >
                    <Form.Item
                        label="Tên đăng nhập"
                        name="username"
                        rules={[{ required: true, message: 'Bạn phải nhập tên đăng nhập!' }]}
                       
                    >
                        <Input placeholder="Nhập tên đăng nhập" className='w-full' name='username'></Input>
                    </Form.Item>
                    <Form.Item
                        label="Mật khẩu"
                        name="password"
                        rules={[{ required: true, message: 'Bạn phải nhập mật khẩu!' }]}
                    >
                        <Input.Password placeholder="Nhập mật khẩu" name='password'></Input.Password>
                    </Form.Item>
                    <Form.Item
                        name="rememberPassword"
                    >
                        <div className='flex flex-row justify-start items-center'>
                            <Checkbox name='rememberPassword'/>
                            <p className='ml-2 text-sm'>Nhớ mật khẩu</p>
                        </div>
                    </Form.Item>
                </Form>
            </ConfigProvider>
            <button className='w-full py-2 bg-primary text-white text-sm rounded mt-4 mb-2' onClick={onSubmit}>Đăng nhập</button>
            <Spin spinning={spinning} fullscreen />
        </div>
    );
};

export default App;